import React from 'react';
import styled, { css } from 'styled-components';

import PlusRoundIcon from '@/assets/svg/plus_round.svg';
import MinusRoundIcon from '@/assets/svg/minus_round.svg';
import { media } from '@/utils/mixin';

interface Props {
  pros: Array<string>;
  cons: Array<string>;
}

function ProsAndCons({ pros, cons }: Props) {
  if (pros.length === 0 && cons.length === 0) return null;

  const filteredPros = pros.filter((item) => item !== null);
  const filtererdCons = cons.filter((item) => item !== null);

  if (filteredPros.length === 0 && filtererdCons.length === 0) return null;

  return (
    <Component>
      {filteredPros.length ? (
        <List>
          {filteredPros.map((text, index) => (
            <Item key={index}>
              <Icon>
                <PlusRoundIcon />
              </Icon>
              <Text>{text}</Text>
            </Item>
          ))}
        </List>
      ) : null}
      {filtererdCons.length ? (
        <List>
          {filtererdCons.map((text, index) => (
            <Item key={index}>
              <Icon>
                <MinusRoundIcon />
              </Icon>
              <Text>{text}</Text>
            </Item>
          ))}
        </List>
      ) : null}
    </Component>
  );
}

export default ProsAndCons;

const Component = styled.div`
  margin: 40px auto;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(css`
    max-width: 100%;
  `)};

  ${media.mobileUp(
    css`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    `
  )};

  @media (min-width: 1400px) {
    margin: 70px auto;
    gap: 40px;
  }
`;

const List = styled.ul`
  padding: 30px 0;

  border-bottom: 1px solid #d0d0d0;

  &:first-child {
    border-top: 1px solid #d0d0d0;
  }

  ${media.mobileUp(
    css`
      padding: 0;
      border-bottom: none;

      &:first-child {
        border-top: none;
      }
    `
  )}
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  padding-left: 0 !important;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
`;

const Text = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1600px) {
    font-size: 24px;
  }
`;
